import { BACKEND_API_URL } from '../consts/api'

export type MediaSizes = Record<string, string | null> & {
  source?: string | null
}

export type MediaResourceLike =
  | {
      id?: number
      sizes?: MediaSizes
      file?: {
        url?: string | null
        sizes?: MediaSizes
      }
    }
  | null
  | undefined

function normalizeMediaUrl(url: string): string {
  const raw = url.trim()
  if (!raw) return raw

  // Уже абсолютный URL (или data/blob) — не трогаем.
  if (/^(https?:)?\/\//i.test(raw) || /^data:/i.test(raw) || /^blob:/i.test(raw)) {
    return raw
  }

  // На бэкенде часто приходят относительные пути (`/storage/...`, `images/...`).
  // Если оставить как есть — браузер запросит их с origin фронта (и попадём в `/images/...` из моков).
  try {
    const baseOrigin = new URL(BACKEND_API_URL).origin
    if (raw.startsWith('/')) return `${baseOrigin}${raw}`
    return `${baseOrigin}/${raw}`
  } catch {
    return raw
  }
}

export function getMediaSourceUrl(media: unknown): string | null {
  if (media == null) return null
  if (typeof media === 'string') {
    const s = media.trim()
    if (!s) return null
    return normalizeMediaUrl(s)
  }
  if (typeof media !== 'object') return null

  const m = media as MediaResourceLike & Record<string, unknown>

  const directSizes = (m as any).sizes as MediaSizes | undefined
  const file = (m as any).file as { url?: string | null; sizes?: MediaSizes } | undefined

  const url =
    (directSizes?.source ?? null) ||
    (file?.sizes?.source ?? null) ||
    (file?.url ?? null)

  if (typeof url !== 'string' || url.trim() === '') return null
  const normalizedUrl = normalizeMediaUrl(url)

  // Cache-busting: при замене media URL может совпадать, а браузер отдаст старый кеш.
  // id из JSON может быть number или numeric string.
  const rawId = (m as any).id
  const idNum = typeof rawId === 'number' ? rawId : Number(rawId)
  if (!Number.isFinite(idNum) || idNum <= 0) return normalizedUrl

  const separator = normalizedUrl.includes('?') ? '&' : '?'
  return `${normalizedUrl}${separator}v=${encodeURIComponent(String(idNum))}`
}

